var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef } from '@angular/core';
import { TherapistScaleResultsComponent } from 'app/reports/report-items/therapist-scale-results/therapist-scale-results.component';
import { ReportNavigatorService } from 'app/reports/services/report-navigator.service';
var ClientScaleResultsComponent = /** @class */ (function (_super) {
    __extends(ClientScaleResultsComponent, _super);
    function ClientScaleResultsComponent(navigator, el) {
        return _super.call(this, navigator, el) || this;
    }
    ClientScaleResultsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ClientScaleResultsComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    ClientScaleResultsComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    ClientScaleResultsComponent.prototype.hasContent = function (scaleResult) {
        if (scaleResult && scaleResult.range) {
            return scaleResult.range.clientContent || scaleResult.range.therapistContent;
        }
        return false;
    };
    ClientScaleResultsComponent.prototype.getContent = function (scaleResult) {
        if (scaleResult && scaleResult.range) {
            if (scaleResult.range.clientContent) {
                return scaleResult.range.clientContent;
            }
            else {
                return scaleResult.range.therapistContent;
            }
        }
        return "";
    };
    return ClientScaleResultsComponent;
}(TherapistScaleResultsComponent));
export { ClientScaleResultsComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/client-scale-results/client-scale-results.component.ts.pre-build-optimizer.js